/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';

import { AnalyticsContext } from 'contexts/AnalyticsContext';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { TargetedOffersContext } from 'contexts/TargetedOffersContext';
import LoggedInfo from '../LoggedInfo';
import RetryOffers from '../RetryOffers';
import SignIn from '../SignIn';
import { TYPES_SIGNIN } from '../constants';

import { LOGIN_CAS_STATE } from 'contexts/AnalyticsContext/Constants';
import { CALL_ORIGIN_TARGETED_OFFERS, COUPON, LOYALTY_ID, TARGETED_OFFERS_SERVICE_ERROR_MESSAGES } from 'contexts/CruiseSearchContext/constants';
import { isLoyaltyId } from 'contexts/CruiseSearchContext/utils/targetedOffers';

function Offers(props) {
	const [typeEmail, typeLoyalty] = TYPES_SIGNIN;
	const [switchAccount, setSwitchAccount] = useState(false);

	const {
		targetedOffersLogged,
		targetedOfferApplied,
		targetedFilters,
		applyFilters,
		errorTargetedOffers,
		removeFromQualifiersSelecting,
		removeParamFromOtherParams,

		updateLoyaltyIDOrEmailLogin,
		loyaltyIDOrEmailLogin,
		isInvalidEmailOrCASId,
		loginOrigin,
		errorTargetedOfferMessage,
		targetedOffers,
		targetedOffersLoading,
	} = useContext(CruiseSearchContext);

	const { removeTargetedOffers, retryTargetedOffersSignIn } = useContext(TargetedOffersContext);

	const { utagTargetedOffersLoad, utagTargetedOffersLogin, loyaltyUser, setLoyaltyUser, utagMyOffersFilter } = useContext(AnalyticsContext);

	const { isNetWorkError } = errorTargetedOffers || {};

	const getLoggedId = () => {
		if (typeEmail == targetedFilters?.TypeSignIn) {
			return targetedFilters?.email;
		}
		if (typeLoyalty == targetedFilters?.TypeSignIn) {
			return targetedFilters?.loyaltyID;
		}
		return '';
	};
	const getTypeSignIn = () => targetedFilters?.TypeSignIn;
	const switchHandler = () => {
		setSwitchAccount(true);
		removeTargetedOffers();
		updateLoyaltyIDOrEmailLogin('');
		removeParamFromOtherParams(`${LOYALTY_ID.urlParam}=${loyaltyIDOrEmailLogin}`);
		removeFromQualifiersSelecting(`${COUPON}:${targetedOfferApplied?.couponCode}`, applyFilters);
	};

	useEffect(() => {
		if (targetedOffersLogged) {
			setSwitchAccount(false);
		}
	}, [targetedOffersLogged]);

	const showSignIn = (valid) => {
		if (valid) return <SignIn {...props} />;
		else
			return (
				<RetryOffers
					onRetry={() => {
						retryTargetedOffersSignIn();
					}}
				/>
			);
	};

	const getLoginInfo = () => {
		const isLoyalty = isLoyaltyId(loyaltyIDOrEmailLogin.trim());
		const inputData = {
			...{ ...(isLoyalty && { loyaltyID: loyaltyIDOrEmailLogin }) },
			...{ ...(!isLoyalty && { email: loyaltyIDOrEmailLogin }) },
		};
		return inputData;
	};

	// TO login success utag Event
	useEffect(() => {
		if (targetedOffersLogged) {
			if (loginOrigin === CALL_ORIGIN_TARGETED_OFFERS.FORM) {
				if (!isInvalidEmailOrCASId && !switchAccount) {
					const inputData = getLoginInfo();
					if (loyaltyUser !== loyaltyIDOrEmailLogin) {
						utagTargetedOffersLogin(inputData, LOGIN_CAS_STATE.SUCCESS);
					}
				}
			}
		}
	}, [isInvalidEmailOrCASId, loyaltyIDOrEmailLogin, loginOrigin, switchAccount, targetedOffersLogged]);

	useEffect(() => {
		if (targetedOffersLoading) {
			setLoyaltyUser('');
		}
	}, [targetedOffersLoading]);

	// TO login error utag Event
	useEffect(() => {
		if (errorTargetedOfferMessage) {
			const inputData = { loyaltyID: null, email: null };
			if (errorTargetedOffers?.code === TARGETED_OFFERS_SERVICE_ERROR_MESSAGES.badRequest || errorTargetedOffers?.isNetWorkError) {
				utagTargetedOffersLogin(inputData, LOGIN_CAS_STATE.TECHNICAL);
			} else {
				utagTargetedOffersLogin(inputData, LOGIN_CAS_STATE.INVALID);
			}
		}
	}, [errorTargetedOfferMessage, errorTargetedOffers]);

	// TO load utag Event
	useEffect(() => {
		if (targetedOffersLogged && !switchAccount) {
			const inputData = { ...getLoginInfo(), length: targetedOffers.length };
			if (loyaltyUser !== loyaltyIDOrEmailLogin) {
				setLoyaltyUser(loyaltyIDOrEmailLogin);
				utagTargetedOffersLoad(inputData, !Object.values(TARGETED_OFFERS_SERVICE_ERROR_MESSAGES).includes(errorTargetedOffers?.code), () =>
					utagMyOffersFilter(targetedOffers, loyaltyIDOrEmailLogin),
				);
			} else {
				utagMyOffersFilter(targetedOffers, loyaltyIDOrEmailLogin);
			}
		}
	}, [targetedOffersLogged, targetedOffers, switchAccount, errorTargetedOffers]);

	return (
		<>
			{targetedOffersLogged && !switchAccount && (
				<LoggedInfo
					typeSignIn={getTypeSignIn()}
					id={getLoggedId()}
					onClickCrownAnchor={() => {
						removeTargetedOffers();
					}}
					onClickSignNow={() => {
						removeTargetedOffers();
					}}
					onClickSwitchAccount={() => {
						switchHandler();
					}}
				/>
			)}
			{(!targetedOffersLogged || switchAccount) && showSignIn(!isNetWorkError)}
		</>
	);
}

export default Offers;
